<template>
  <div class="animated fadeIn basic-heading">
    <div class="clearfix">
      <span :class="headerSize">
        <slot>
          {{ title }}
        </slot>
      </span>
      <span class="float-right">
        <slot name="right-content" />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "BasicHeading",
  props: {
    title: {
      type: String,
      default: "Title",
    },
    size: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    headerSize() {
      return `display-4 font-${this.size}xl`;
    },
  },
};
</script>
